export const environment = {
    production: true,
    apiKey: 'Qs3P9uZf29JNEwpnWjgGNFnNvZXT8FuXyDhXEa8bh',
    copApiKey: '2bif7DYHhzVBBM3yaBcxjfXCXZMcd3CcWHkCKPtVk',
    apiUrl: 'https://backend.kaistav2.bassadoneservices.com',
    brands: [
        {
            name: 'Hyundai',
            id: '0563f101-adad-4e0b-9e5a-3a8c0f954057',
            gtmId: 'GTM-PBVWZR7B'
        },
        {
            name: 'Nissan',
            id: 'd262bfbc-35bd-4d39-b804-29b401721239',
        },
        {
            name: 'Renault',
            id: '62e979b9-5ccd-44df-9f6d-453788150ab4',
            gtmId: 'GTM-PNJDR2X'
        },
        {
            name: 'Dacia',
            id: '47f1bf8f-198e-4236-9b54-e0fd78d90c56',
            gtmId: 'GTM-KWLC38P'
        },
        {
            name: 'KGM',
            id: 'c8092d87-b84e-4628-ab02-58532b387dd3',
        },
        {
            name: 'Isuzu',
            id: 'e4109617-dfeb-45d8-91f4-fb8f8d781fa0',
        },
        {
            name: 'Suzuki',
            id: 'a2461732-77d7-4341-ab72-1a6a425234d5',
        }
    ]
};
